import styled from 'styled-components';
import { theme } from '@jadwalh/ui';

export const CheckboxWrapper = styled.div`
  margin-bottom: ${theme.space_size};
  label {
    font-size: 14px;
  }
  .mantine-Checkbox-input {
    border-radius: 4px !important;
    border-color: ${theme.colours.blackText} !important;
    cursor: pointer;
    :checked {
      background-color: ${theme.colours.blackText} !important;
      border-color: ${theme.colours.blackText} !important;
    }
  }
`;
